'use strict';

angular.module('licensure.services')
    .factory('MergeObjects', ['$http', '$q', function ($http, $q) {
        return {
            get: function (code) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/MergeObjects', {
                        params: {
                            code: code
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;